import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { Card } from "react-bootstrap";

const Donate = () => {
    const { t } = useTranslation();

    const cardStyle = {
        border: "none",
        boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
        borderRadius: "18px",
        marginBottom: "3rem",
        overflow: "hidden",
        backgroundColor: "#fff",
    };

    const imgStyle = {
        width: "100%",
        maxWidth: "320px",
        height: "auto",
        maxHeight: "320px",
        objectFit: "contain",
        borderRadius: "12px",
        flexShrink: 0,
    };

    const sectionTitle = {
        color: "#58c459",
        fontWeight: "700",
        textAlign: "center",
        marginBottom: "2rem",
    };

    const headingStyle = {
        color: "#58c459",
        fontWeight: "600",
        marginBottom: "1rem",
    };

    return (
        <div className="container py-5">
            <h1 style={sectionTitle}>{t("donate.subtitle-1")}</h1>
            <h5 className="text-center mb-5 text-muted">{t("donate.subtitle-2")}</h5>

            {/* REpont Support */}
            <Card
                style={cardStyle}
                className="p-4 d-flex flex-column flex-md-row align-items-center text-center text-md-start"
            >
                <img
                    src="../img/repont-qr.png"
                    alt="REpont QR"
                    style={imgStyle}
                    className="mb-4 mb-md-0 me-md-4"
                />
                <div className="flex-grow-1">
                    <h4 style={headingStyle}>{t("donate.repont.title")}</h4>
                    <p className="mb-2">{t("donate.repont.content-1")}</p>
                    <p className="mb-2">{t("donate.repont.content-2")}</p>
                    <ul style={{ marginLeft: "1rem", textAlign: "left", listStyleType: "disc" }}>
                        <li>{t("donate.repont.content-3")}</li>
                        <li>{t("donate.repont.content-4")}</li>
                    </ul>
                    <p className="mt-3 text-muted mb-0">
                        {t("donate.repont.content-5")}
                    </p>
                </div>
            </Card>

            {/* Bank Transfer */}
            <Card
                style={cardStyle}
                className="p-4 d-flex flex-column flex-md-row align-items-center text-center text-md-start"
            >
                <img
                    src="../img/donate-1.jpg"
                    alt="Bank Transfer"
                    style={imgStyle}
                    className="mb-4 mb-md-0 me-md-4"
                />
                <div className="flex-grow-1 w-100">
                    <h4 style={headingStyle}>{t("donate.list-title-1")}</h4>

                    {/* Two-column bank info layout */}
                    <div className="row">
                        {/* Local transfer info */}
                        <div className="col-md-6 mb-3 mb-md-0">
                            <p className="mb-1">
                                <strong>{t("donate.content-1")}</strong>
                                <br />
                                {t("donate.content-2")}
                                <br />
                                {t("donate.content-3")}
                            </p>
                        </div>

                        {/* International transfer info */}
                        <div className="col-md-6">
                            <p className="mb-1">
                                <strong>{t("donate.content-4")}</strong>
                                <br />
                                {t("donate.content-5")}
                                <br />
                                {t("donate.content-6")}
                            </p>
                        </div>
                    </div>
                </div>
            </Card>

            {/* Item Donation */}
            <Card
                style={cardStyle}
                className="p-4 d-flex flex-column flex-md-row align-items-center text-center text-md-start"
            >
                <img
                    src="../img/donate-2.jpg"
                    alt="Item Donation"
                    style={imgStyle}
                    className="mb-4 mb-md-0 me-md-4"
                />
                <div className="flex-grow-1">
                    <h4 style={headingStyle}>{t("donate.list-title-2")}</h4>
                    <p>
                        {t("donate.content-7")}{" "}
                        <NavLink
                            to="/donating-items-to-us"
                            style={{ color: "#58c459", textDecoration: "none", fontWeight: 600 }}
                            onMouseOver={(e) =>
                                (e.target.style.textDecoration = "underline")
                            }
                            onMouseOut={(e) => (e.target.style.textDecoration = "none")}
                        >
                            {t("donate.content-8")}
                        </NavLink>{" "}
                        {t("donate.content-9")}
                    </p>
                </div>
            </Card>
        </div>
    );
};

export default Donate;
